import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ContainerBooking } from '../models/container-booking';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ContainerBookingService {
    private path: string;
    private baseUrl: string = "";

    constructor(private http: HttpClient) {
        this.path = "api/v1/ContainerBooking";
        this.baseUrl = environment.apiUrl;
    }

    create(model: ContainerBooking): Observable<ContainerBooking> {
        return this.http.post<any>(this.baseUrl + this.path, model).pipe(
            catchError((error: HttpErrorResponse) => {
                return throwError(error);
            })
        );
    }

}
